import { GET_SINGLE_WOCOMMERCE, GET_WOCOMMERCE } from "../../actions/type";

// activity intial state
const initialWocommerce = {
    allWocommerce: null,
    wocommerceForEdit:null,
    isLoading: true,
    isEditLoading: true,
};

export const reducer = (state = initialWocommerce, action) => {
    switch (action.type) {
        case GET_WOCOMMERCE: {
            const allWocommerce = action.payload;
            return {
                ...state,
                allWocommerce: allWocommerce,
                isLoading: false,
            };
        }
        case GET_SINGLE_WOCOMMERCE: {
            const wocommerceForEdit = action.payload;
            return {
                ...state,
                wocommerceForEdit,
                isEditLoading: false,
            };
        }
        default:
            return state;
    }
};